(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header_old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["silo-popup-talk"] && !Shopify.designMode) return;
  try {
    
if (!window.SiloPopupCall) {
  class SiloPopupCall {
    constructor(root) {
      if (!root || !(root instanceof HTMLElement)) throw new Error('SiloPopupCall: missing valid root element');
      this.root   = root;
      this.key    = root.dataset.popupKey || 'silo-default';
      this.mode   = (root.dataset.mode || 'survey').toLowerCase();
      this.triggerSelector = root.dataset.triggerSelector || '#talkToUs';

      this.inner  = root.querySelector('.silo-popup__inner, .main-popup, #silo-popup-inner');
      this.loader = root.querySelector('.silo-popup__loader, #silo-loader') || document.getElementById('silo-loader');
      this.form   = root.querySelector('#popup-email-formCall, #popup-email-form, form[data-silo-form="true"]');

      this._bind();
      this._applyBackground();
    }

    _bind() {
      // Open trigger
      if (this.triggerSelector) {
        document.querySelectorAll(this.triggerSelector).forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
          }, { passive: false });
        });
      }

      // Close on [data-close="true"]
      this.root.addEventListener('click', (e) => {
        const closeEl = e.target.closest('[data-close="true"]');
        if (closeEl && this.root.contains(closeEl)) {
          e.preventDefault();
          this.close();
        }
      });

      // Submit handler
      if (this.form) {
        this.form.addEventListener('submit', async (e) => {
          e.preventDefault();
          this._showLoader(true);
          try {
            const resp = await this._submitFormAjax();
            this.form.innerHTML = `
              <div class="successCall" role="status" aria-live="polite">
                <svg xmlns="http://www.w3.org/2000/svg" width="51" height="50" viewBox="0 0 51 50" fill="none" aria-hidden="true" focusable="false">
                  <path d="M25.5 0.0976562C11.7469 0.0976562 0.597656 11.2469 0.597656 25C0.597656 38.7531 11.7469 49.9023 25.5 49.9023C39.2531 49.9023 50.4023 38.7531 50.4023 25C50.4023 11.2469 39.2531 0.0976562 25.5 0.0976562ZM39.8918 21.1234L24.7828 36.2336C23.8512 37.1652 22.6125 37.6785 21.2953 37.6785C19.9781 37.6785 18.7395 37.1652 17.8078 36.2336L11.1082 29.534C10.1355 28.5613 9.6 27.2664 9.6 25.8883C9.6 24.5102 10.1355 23.2152 11.1082 22.2426C12.082 21.2687 13.377 20.732 14.7539 20.732C16.1309 20.732 17.4258 21.2687 18.3996 22.2426L21.2953 25.1371L32.6004 13.832C33.5742 12.8582 34.8691 12.3215 36.2461 12.3215C37.623 12.3215 38.918 12.8582 39.8918 13.832C40.8645 14.8047 41.4 16.0996 41.4 17.4777C41.4 18.8559 40.8645 20.1508 39.8918 21.1234Z" fill="#00633C"/>
                </svg>
                <h2>Thank you!</h2>
                <p>We’ll contact you soon.</p>
              </div>
            `;
            this.root.dispatchEvent(new CustomEvent('silo:popup:formSubmitted', { detail: resp }));
          } catch (err) {
            console.error('Popup form submit failed:', err);
            alert('Something went wrong. Please try again.');
          } finally {
            this._showLoader(false);
          }
        });
      }
    }

    _parseJson(str, fallback = {}) { try { return JSON.parse(str); } catch { return fallback; } }

    _getReferrerDomain() {
      const ref = document.referrer || '';
      if (!ref) return '';
      try { return new URL(ref).hostname.replace(/^www\./,''); }
      catch { return ref.replace(/^https?:\/\//,'').split('/')[0].replace(/^www\./,''); }
    }

    async _getCampaignParams() {
      const raw = await this.getCookieSafe('ab_campaign_params');
      if (raw) return this._parseJson(raw, {});
      const params = new URLSearchParams(window.location.search);
      const obj = {};
      [
        'utm_source','utm_medium','utm_campaign','utm_term','utm_content',
        'fbclid','gclid','gad_source','gad_campaignid','click_id','utm_id'
      ].forEach((k) => { const v = params.get(k); if (v) obj[k] = v; });
      return obj;
    }

    async _getActiveTests() {
      const raw = await this.getCookieSafe('ab_active_tests');
      return raw ? this._parseJson(raw, {}) : {};
    }

    async _getInitialLandingUrl() {
      return (await this.getCookieSafe('initial_landing_url')) || window.location.href;
    }

    _getDeviceInfo() {
      return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenResolution: `${window.screen?.width || 0}x${window.screen?.height || 0}`
      };
    }

    _deriveClickId(utms = {}) { return utms.fbclid || utms.gclid || utms.click_id || utms.utm_id || null; }

    _extractCoreFormFields(formObj = {}) {
      const keyOf = (re) => Object.keys(formObj).find((k) => re.test(k));
      const nameKey  = keyOf(/^(name|full\s*name|contact\[name\]\d*|contact\[name\])$/i);
      const phoneKey = keyOf(/^(phone|tel|contact\[phone\]\d*|contact\[phne\]\d*|contact\[phone\])$/i);
      const emailKey = keyOf(/^(email|contact\[email\]\d*|contact\[email\])$/i);
      return {
        name : nameKey  ? String(formObj[nameKey]).trim()  : null,
        phone: phoneKey ? String(formObj[phoneKey]).trim() : null,
        email: emailKey ? String(formObj[emailKey]).trim() : null
      };
    }

    async _submitFormAjax() {
      const sessionId = await this.getCookieSafe('ab_session_id');
      const userId    = await this.getCookieSafe('ab_user_id');
      const utms   = await this._getCampaignParams();
      const tests  = await this._getActiveTests();
      const device = this._getDeviceInfo();
      const initialLandingUrl = await this._getInitialLandingUrl();
      const referrerDomain    = this._getReferrerDomain();
      const form = this._collectFormData();
      const { name, phone, email } = this._extractCoreFormFields(form);

      let tempId;
      if (!sessionId) {
        tempId = (crypto?.randomUUID && crypto.randomUUID()) || String(Date.now());
        try {
          document.cookie = `ab_session_id=${encodeURIComponent(tempId)}; path=/; max-age=${60*60*24*7}`;
        } catch {}
      }

      const endpoint =
        this.form?.getAttribute('action') ||
        this.root?.dataset.endpoint ||
        'https://ab-test-node-5f422db672ba.herokuapp.com/api/v1/leads';

      const payload = {
        sessionId: sessionId || tempId,
        userId,
        lead: { sessionId: sessionId || tempId, userId, name, phone, email, status: 'new', notes: '' },
        popup: { key: this.key, mode: this.mode },
        page: { url: window.location.href, referrerDomain, initialLandingUrl },
        utms,
        clickId: this._deriveClickId(utms),
        testAssignments: tests,
        form,
        device,
        ts: new Date().toISOString()
      };

      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) {
        const text = await res.text().catch(() => '');
        throw new Error(`HTTP ${res.status} ${res.statusText} ${text}`);
      }
      try { return await res.json(); } catch { return { ok: true }; }
    }

    async getCookieSafe(name) {
      try {
        // optional extension hook
        if (window.browser && browser.cookie && typeof browser.cookie.get === 'function') {
          const v = await browser.cookie.get(name);
          if (v) return v;
        }
      } catch {}
      const m = document.cookie.split('; ').find(r => r.startsWith(name + '='));
      return m ? decodeURIComponent(m.split('=').slice(1).join('=')) : null;
    }

    _collectFormData() {
      if (!this.form) return {};
      const fd = new FormData(this.form);
      const obj = {};
      fd.forEach((val, key) => {
        if (key in obj) {
          Array.isArray(obj[key]) ? obj[key].push(val) : (obj[key] = [obj[key], val]);
        } else {
          obj[key] = val;
        }
      });
      return obj;
    }

    _applyBackground() {
      const desktop = this.root.dataset.bgDesktop;
      const mobile  = this.root.dataset.bgMobile;
      if (!this.inner) return;

      const apply = () => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        const src = (isMobile && mobile) ? mobile : desktop;
        if (src) {
          this.inner.style.backgroundImage = `url(${src})`;
          this.inner.style.backgroundSize = 'cover';
          this.inner.style.backgroundPosition = 'center';
        }
      };
      apply();
      window.addEventListener('resize', this._throttle(apply, 200));
    }

    open() {
      this.root.style.display = 'flex';
      requestAnimationFrame(() => {
        this.root.classList.add('popup-visible');
        document.documentElement.classList.add('modal-overflow-hidden');
        this.root.setAttribute('aria-hidden', 'false');
      });
    }

    close() {
      this.root.classList.remove('popup-visible');
      document.documentElement.classList.remove('modal-overflow-hidden');
      this.root.setAttribute('aria-hidden', 'true');
      setTimeout(() => { this.root.style.display = 'none'; }, 250);
    }

    _showLoader(show) {
      if (!this.loader) return;
      this.loader.hidden = !show;
    }

    _throttle(fn, ms) {
      let last = 0;
      return (...args) => {
        const now = performance.now();
        if (now - last > ms) { last = now; fn(...args); }
      };
    }
  }

  window.SiloPopupCall = SiloPopupCall;

  document.addEventListener('DOMContentLoaded', () => {
    const nodes = document.querySelectorAll('.silo-popupCall');
    nodes.forEach((node) => {
      if (!node.__siloInstance) {
        node.__siloInstance = new SiloPopupCall(node);
        if (String(node.dataset.autoOpen).toLowerCase() === 'true') {
          node.__siloInstance.open();
        }
      }
    });
  });
}

  } catch(e) { console.error(e); }
})();
})();
